//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import notificationMixin from '@/mixins/notificationMixin'
import ProjectActionsContainerSimple from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainerSimple.vue'
import TableUsersInfo from '@/components/Projects/NewProjectSteps/shared/TableUsersInfo.vue'
import Button from '~/components/Shared/Button'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'

export default {
  name: 'MassiveImportInfoUserModal',
  components: {
    Button,
    ProjectActionsContainerSimple,
    ProjectModalAddUsers,
    TableUsersInfo,
  },
  mixins: [handleErrorMixin, notificationMixin],
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    usersInfo: {
      type: Array,
      default: () => [],
    },
    sendInvitation: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: Number,
      required: true,
    },
    supervisorId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      active: this.value,
    }
  },
  computed: {
    isDisabled() {
      return this.usersInfo
        .map((userInfo) => userInfo.errors)
        .some((userError) => userError.length > 0)
    },
  },
  watch: {
    value() {
      this.active = this.value
    },
    active(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    async createUsers() {
      this.$store.commit('loading', true)
      try {
        const users = await this.$repository.invitation.newMassCreateCollaborators(
          {
            users: this.usersInfo,
            sendInvitation: this.sendInvitation,
            projectId: this.projectId,
          }
        )
        await this.$repository.supervisorAssignments.saveMassiveCollaborators({
          collaboratorsIds: users.map((user) => user.id),
          supervisorId: this.supervisorId,
          projectId: this.projectId,
          validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
          sendInvitationEmail: this.sendInvitation,
        })
        this.$repository.projectRoles.updateValidationStatus(
          this.projectId,
          this.supervisorId,
          this.sendInvitation
        )
        this.successNotification(
          'Los usuarios se han añadido correctamente al proyecto.'
        )
      } catch (e) {
        this.handleError(e, 'No se pudo añadir los usuarios al proyecto.')
      } finally {
        this.$store.commit('loading', false)
        this.$emit('confirm-mass-invitation')
        this.active = false
      }
    },
  },
}
